<template>
  <v-container fluid>
    <v-card>
      <v-container fluid>
        <v-form :disabled="buscando" @submit.prevent="buscarItensNotaFiscal">
          <v-row>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.descricaoProduto"
                label="Descrição Produto"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.codigoBarra"
                label="Código Barra"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field v-model="filtro.ncm" label="NCM" :loading="buscando" />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field v-model="filtro.cliente" label="Cliente" :loading="buscando" />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field v-model="filtro.uf" label="UF Destino" :loading="buscando" />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.numeroNF"
                label="Número NF"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.chaveNF"
                label="Chave NF"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field v-model="filtro.cnpj" label="CNPJ" :loading="buscando" type="number" />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.nomeFornecedor"
                label="Nome Fornecedor"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.cfop"
                label="Código CFOP"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.cstIcms"
                label="CST ICMS"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="4" sm="4">
              <v-text-field
                v-model="filtro.cstPis"
                label="CST PIS"
                :loading="buscando"
                type="number"
              />
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
              <v-btn class="ml-4" color="primary" outlined type="submit" :loading="buscando">
                <v-icon left> mdi-magnify </v-icon>
                Pesquisar
              </v-btn>
              <v-btn
                class="ml-4"
                color="normal"
                outlined
                type="submit"
                :loading="buscando"
                @click.stop.prevent="limparSelecaoDeFiltros"
              >
                <v-icon left> mdi-autorenew </v-icon>
                Limpar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-2">
      <v-container fluid>
        <v-form :disabled="!podeImportar() || buscando" @submit.prevent="buscarItensCliente">
          <v-row align="center" justify="center">
            <v-col>
              <v-file-input
                required
                accept="text/xml"
                label="Inserir um ou mais XML"
                :disabled="!permiteInserirXml"
                multiple
                @change="(file) => selectFile(file, 'xml')"
              />
            </v-col>

            <v-col>
              <v-file-input
                required
                accept="application/zip"
                label="Inserir ZIP"
                :disabled="!permiteInserirZip"
                @change="(file) => selectFile(file, 'zip')"
              />
            </v-col>

            <v-col class="d-flex align-center flex-column">
              <v-btn :disabled="!permiteImportarXml" color="primary" @click="importarXml">
                Importar XML
              </v-btn>
              <span v-if="!podeImportar()" class="red--text text-body-2">
                Sem permissão para importar
              </span>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-2">
      <v-container fluid>
        <v-data-table
          :headers="headers"
          :loading="buscando"
          :items="itensNotaFiscal"
          item-class="class"
          item-key="itemNF.id"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30, 50] }"
        >
          <template #[`item.notaFiscal`]="{ item }">
            <span>{{ `${item.numero}/${item.serie}` }}</span>
          </template>

          <template #[`item.dataHoraEmissao`]="{ item }">
            <span>{{ formatDateTime(item.dataHoraEmissao) }}</span>
          </template>

          <template #[`item.fornecedor`]="{ item }">
            <span>{{ item.fornecedor.documento }}</span>
            <v-divider />
            <span>{{ item.fornecedor.nome }}</span>
          </template>

          <template #[`item.empresa`]="{ item }">
            <span>{{ item.empresa.documento }}</span>
            <v-divider />
            <span>{{ item.empresa.nome }}</span>
          </template>

          <template #[`item.produto`]="{ item }">
            <span>{{ item.itemNF.descricao }}</span>
            <v-divider />
            <span>{{ item.itemNF.codigoBarra }}</span>
          </template>

          <template #[`item.valores`]="{ item }">
            <span>{{ `U: ${item.itemNF.valorUnitario}` }}</span>
            <v-divider />
            <span>{{ `T: ${item.itemNF.valorTotal}` }}</span>
          </template>

          <template #[`item.icms`]="{ item }">
            <span>{{ `${item.itemNF.porcentagemIcms}%` }}</span>
            <v-divider />
            <span>{{ `CST: ${item.itemNF.cstIcms.codigo}` }}</span>
            <v-divider />
            <span>{{ `Redu: ${item.itemNF.reducaoIcms}` }}</span>
          </template>

          <template #[`item.pis`]="{ item }">
            <span>{{ item.itemNF.cstPis.codigo }}</span>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="showDialogErroImportacao" persistent max-width="900">
      <v-card max-height="80vh">
        <v-card-title class="headline">Importações com erros</v-card-title>
        <v-card-text>
          <v-list color="py-0 mt-5">
            <v-list-item v-for="(item, i) in importacoesComErro" :key="i">
              <span>
                <strong> {{ item.nomeArquivo }} </strong> {{ ' -> ' + item.errorMessage }}
              </span>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="red darken-1" @click="showDialogErroImportacao = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NotaFiscalService from '@/services/notaFiscal/notaFiscal'
import ArquivoConsultoriaService from '@/services/arquivoConsultoria/arquivoConsultoria'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import { formatDateTime } from '@/shareds/formatacoes'
import { ID_TELA_DE_NFES } from '@/common/constants'
import store from '@/store'
import JSZip from 'jszip'

export default {
  components: {
    SnackbarMessage
  },

  data: () => ({
    itensNotaFiscal: [],
    headers: [
      { text: 'Nota', value: 'notaFiscal', divider: true },
      { text: 'Emissão', value: 'dataHoraEmissao', divider: true },
      { text: 'Fornecedor', value: 'fornecedor', divider: true },
      { text: 'Empresa', value: 'empresa', divider: true },
      { text: 'UF', value: 'uf.sigla', divider: true },
      { text: 'Item', value: 'produto', divider: true },
      { text: 'NCM', value: 'itemNF.ncm.codigo', divider: true },
      { text: 'Valor', value: 'valores', divider: true },
      { text: 'Qtde', value: 'itemNF.quantidade', divider: true },
      { text: 'ICMS', value: 'icms', divider: true },
      { text: 'PIS', value: 'pis', divider: true }
    ],
    filtro: {},
    buscando: false,
    snackbar: new SnackBar(),
    arquivosXmlUpload: [],
    arquivoZipUpload: null,
    importacoesComErro: [],
    showDialogErroImportacao: false,
    formatDateTime: formatDateTime,
    ID_TELA_DE_NFES: ID_TELA_DE_NFES
  }),

  computed: {
    permiteImportarXml() {
      return this.arquivosXmlUpload.length > 0 || this.arquivoZipUpload
    },
    permiteInserirZip() {
      return this.arquivosXmlUpload.length === 0
    },
    permiteInserirXml() {
      return !this.arquivoZipUpload
    }
  },

  created() {
    if (this.$route.query.descricao) {
      this.filtro.descricaoProduto = this.$route.query.descricao
      this.buscarItensNotaFiscal()
    }

    if (this.$route.query.codigoDeBarras) {
      this.filtro.codigoBarra = this.$route.query.codigoDeBarras
      this.buscarItensNotaFiscal()
    }
  },

  methods: {
    podeImportar() {
      return store.getters.verificaSeTemPermissao(ID_TELA_DE_NFES, 'ADICIONAR')
    },

    async buscarItensNotaFiscal() {
      if (
        !this.filtro.descricaoProduto &&
        !this.filtro.codigoBarra &&
        !this.filtro.ncm &&
        !this.filtro.cliente &&
        !this.filtro.uf &&
        !this.filtro.numeroNF &&
        !this.filtro.chaveNF &&
        !this.filtro.cnpj &&
        !this.filtro.nomeFornecedor &&
        !this.filtro.cfop &&
        !this.filtro.cstIcms &&
        !this.filtro.cstPis
      ) {
        this.snackbar.snackTextParam =
          'É necessário informar ao menos um filtro antes de realizar a pesquisa.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
        return
      }

      this.buscando = true

      const response = await NotaFiscalService.getAllItens({
        descricaoProduto: this.filtro.descricaoProduto || undefined,
        codigoBarra: this.filtro.codigoBarra || undefined,
        ncm: this.filtro.ncm || undefined,
        cliente: this.filtro.cliente || undefined,
        uf: this.filtro.uf || undefined,
        numeroNF: this.filtro.numeroNF || undefined,
        chaveNF: this.filtro.chaveNF || undefined,
        cnpj: this.filtro.cnpj || undefined,
        nomeFornecedor: this.filtro.nomeFornecedor || undefined,
        cfop: this.filtro.cfop || undefined,
        cstIcms: this.filtro.cstIcms || undefined,
        cstPis: this.filtro.cstPis || undefined
      })

      this.itensNotaFiscal = response
      this.buscando = false
    },

    async importarXml() {
      let arrSize
      let count = 0
      this.buscando = true
      this.importacoesComErro = []

      if (this.arquivoZipUpload) {
        const files = await this.lerZip(this.arquivoZipUpload)

        arrSize = files.length

        for (const file of files) {
          try {
            await ArquivoConsultoriaService.uploadXml({
              arquivo: file.arquivo,
              nomeArquivo: file.nomeArquivo,
              tamanhoArquivo: null
            })
          } catch (error) {
            const errorMessage = `${
              error.response.data.message === undefined
                ? error.message
                : error.response.data.message
                ? error.response.data.message
                : 'Ocorreu um erro ao importar o arquivo.'
            }`

            this.importacoesComErro.push({ nomeArquivo: file.nomeArquivo, errorMessage })
          } finally {
            count++
            if (count >= arrSize) this.finalizarImportacao()
          }
        }
      } else {
        arrSize = this.arquivosXmlUpload.length

        for (const arquivoXml of this.arquivosXmlUpload) {
          const contentFile = await this.lerXml(arquivoXml)

          try {
            await ArquivoConsultoriaService.uploadXml({
              arquivo: contentFile,
              nomeArquivo: arquivoXml.name,
              tamanhoArquivo: arquivoXml.size
            })
          } catch (error) {
            const errorMessage = `${
              error.response.data.message === undefined
                ? error.message
                : error.response.data.message
                ? error.response.data.message
                : 'Ocorreu um erro ao importar o arquivo.'
            }`
            this.importacoesComErro.push({ nomeArquivo: arquivoXml.name, errorMessage })
          } finally {
            count++
            if (count >= arrSize) this.finalizarImportacao()
          }
        }
      }
    },

    lerZip(arquivoZip) {
      var zip = new JSZip()
      let arrSize
      let count = 0
      let contentsFiles = []

      return new Promise((resolve, reject) => {
        try {
          zip.loadAsync(arquivoZip).then((contents) => {
            const files = Object.keys(contents.files)
            arrSize = files.length

            for (const filename of files) {
              zip.files[filename].async('string').then((contentFile) => {
                contentsFiles.push({ nomeArquivo: filename, arquivo: contentFile })
                count++
                if (arrSize === count) {
                  resolve(contentsFiles)
                }
              })
            }
          })
        } catch (error) {
          reject(error)
        }
      })
    },

    lerXml(arquivoXml) {
      let reader = new FileReader()

      return new Promise((resolve, reject) => {
        reader.onerror = () => {
          reader.abort()
          reject(new DOMException('Problem parsing input file.'))
        }

        reader.onload = () => {
          resolve(reader.result)
        }
        reader.readAsText(arquivoXml)
      })
    },

    finalizarImportacao() {
      if (this.importacoesComErro.length > 0) {
        this.showDialogErroImportacao = true
      } else {
        this.snackbar.snackTextParam = `Arquivo(s) XML importado(s) com sucesso.`
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
      }

      this.arquivosXmlUpload = ''
      this.arquivoZipUpload = ''
      this.buscando = false
    },

    selectFile(file, tipo) {
      if (!file) {
        this.nfe = {}
      }
      this.xmlErrorMessage = ''
      if (tipo === 'xml') this.arquivosXmlUpload = file
      else if (tipo === 'zip') this.arquivoZipUpload = file
    },

    limparSelecaoDeFiltros() {
      this.filtro = {
        descricaoProduto: '',
        codigoBarra: '',
        ncm: '',
        cliente: '',
        uf: '',
        numeroNF: '',
        chaveNF: '',
        cnpj: '',
        nomeFornecedor: '',
        cfop: '',
        cstIcms: '',
        cstPis: ''
      }
    }
  }
}
</script>

<style>
.theme--light.v-data-table tr {
  height: 70px;
}
</style>
